import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { IRegEdMetadataForm } from './types';

export const REGED_METADATA_SCHEMA_QUERY_KEY = 'regEdMetadataSchema';

export const useRegEdMetadataSchemaQuery = (
	format: string | null | undefined,
	{ enabled = true, impersonationContext }: { enabled?: boolean; impersonationContext?: Api.IImpersonationContext } = {}
) => {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!format,
		queryKey: [REGED_METADATA_SCHEMA_QUERY_KEY, format ?? null, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IRegEdMetadataForm>({
				path: Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { format: format! },
					urlPath: 'compliance/regEd/metadataSchema',
				}),
				method: 'GET',
				throwOn404: false,
			}),
		meta: {
			toastErrorMessage: 'Failed to load the compliance metadata form.',
		},
	});
};

export const invalidateRegEdMetadataSchema = (format?: string) => {
	reactQueryClient.invalidateQueries({
		queryKey: format ? [REGED_METADATA_SCHEMA_QUERY_KEY, format] : [REGED_METADATA_SCHEMA_QUERY_KEY],
	});
};
